import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styled from "@emotion/styled";
import ETH from "../../../../assets/Images/eth.png";
import SHIA from "../../../../assets/Images/shia.png";
import USDT from "../../../../assets/Images/usdt.png";
import USDC from "../../../../assets/Images/usdc.png";
import DAI from "../../../../assets/Images/dai.png";
import { Image } from "../../../Styles/style";
import Paragraph from "../../MainComponent/Paragraph";
import CustomButton from "../../MainComponent/CustomBtn";

const RowDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  column-gap: 5px;
`;
const CoulmnDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;
const TContainer = styled(TableContainer)`
  background-color: transparent !important;
  font-family: PoppinsB !important;
  color: #707070 !important;
  box-shadow: none;
`;
const TCell = styled(TableCell)`
  font-family: PoppinsB !important;
  color: #707070 !important;
  text-align: left;
  padding: 5px;
`;
function createData(Assets, WalletBalance, DepositAPY, Collateral) {
  return { Assets, WalletBalance, DepositAPY, Collateral };
}

export default function AssetsToSupplyHomeTable() {
  const rows = [
    createData(
      <RowDiv>
        <Image mw="20px" src={ETH} />
        <Paragraph fs="14px" p="0" ta="left">
          ETH
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0.005
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          $50
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        1.5%
      </Paragraph>,
      <Paragraph fs="14px" color="red" p="0" ta="left">
        No
      </Paragraph>
    ),
    createData(
      <RowDiv>
        <Image mw="20px" src={SHIA} />
        <Paragraph fs="14px" p="0" ta="left">
          SHIA
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          1000
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          %100
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        0.0%
      </Paragraph>,
      <Paragraph fs="12px" color="#9CFF1A" p="0" ta="left">
        Yes
      </Paragraph>
    ),
    createData(
      <RowDiv>
        <Image mw="20px" src={USDT} />
        <Paragraph fs="14px" p="0" ta="left">
          USDT
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          %0
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        0.7%
      </Paragraph>,
      <Paragraph fs="14px" color="red" p="0" ta="left">
        No
      </Paragraph>
    ),
    createData(
      <RowDiv>
        <Image mw="20px" src={USDC} />
        <Paragraph fs="14px" p="0" ta="left">
          USDC
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          %0
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        0.5%
      </Paragraph>,
      <Paragraph fs="14px" color="red" p="0" ta="left">
        No
      </Paragraph>
    ),
    createData(
      <RowDiv>
        <Image mw="20px" src={DAI} />
        <Paragraph fs="14px" p="0" ta="left">
          DAI
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          %0
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        16.0%
      </Paragraph>,
      <Paragraph fs="14px" color="red" p="0" ta="left">
        No
      </Paragraph>
    ),
  ];
  return (
    <TContainer component={Paper}>
      <Table sx={{ minWidth: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TCell>Assets</TCell>
            <TCell align="right">Wallet balance</TCell>
            <TCell align="right">APY</TCell>
            <TCell align="right">Collateral</TCell>
            <TCell align="right">&nbsp;</TCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.Assets}
              </TableCell>
              <TableCell align="right">{row.WalletBalance}</TableCell>
              <TableCell align="right">{row.DepositAPY}</TableCell>
              <TableCell align="right">{row.Collateral}</TableCell>
              <TableCell align="right">
                <CustomButton
                  w="90px"
                  p="4px 10px"
                  b="1px solid #FE9C02"
                  c="#FE9C02"
                  bgc="transparent"
                  hbgc="transparent"
                  hc="#FE9C02"
                >
                  Supply
                </CustomButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TContainer>
  );
}
